import React from 'react';
import { useLocation } from 'react-router-dom';

const IfcViewer: React.FC = () => {
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const fileUrl = params.get('url') || '';

  const viewerBase = process.env.NODE_ENV === 'production'
    ? 'https://portalis.pointreef.cloud/ifc-viewer'
    : 'http://localhost:5173';

  return (
    <iframe
      src={`${viewerBase}/?url=${encodeURIComponent(fileUrl)}`}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        border: 'none',
      }}
      title="IFC Viewer"
    />
  );
};

export default IfcViewer;
